<nb-card>
  <nb-card-header class="p-0">
    <span class="title">{{ title || ('theme.confirmation-dialog.label' | translate) }}</span>
  </nb-card-header>
  <nb-card-body class="p-0 pb-3">
    <p>
      <br/>
      <span>{{ label }}</span>
    </p>
  </nb-card-body>
  <nb-card-footer class="text-right">
    @if (showThreeButtons) {
    <button nbButton status="warning" class="cancel-button" (click)="close()">{{ 'Cancel' | translate }}</button>
    &nbsp;
    <button nbButton status="warning" class="cancel-button" (click)="reject()">{{ 'No' | translate }}</button>
    &nbsp;
    <button nbButton (click)="confirm()">{{ 'Yes' | translate }}</button>
    } @else {
    <button nbButton status="warning" class="cancel-button" (click)="close()">{{ 'theme.confirmation-dialog.close' | translate }}</button>
    &nbsp;
    <button nbButton (click)="confirm()">{{ 'theme.confirmation-dialog.submit' | translate }}</button>
    }
  </nb-card-footer>
</nb-card>
